export default "__VITE_ASSET__M88XSai7__"